export default () => {
  document.querySelectorAll('.inline-video').forEach((inlineVideo) => {
    const startVideo = inlineVideo.querySelector('.inline-video__start');
    const loopVideo = inlineVideo.querySelector('.inline-video__loop');

    if (!startVideo && !loopVideo) return;

    let initialized = false;

    function initialize() {
      if (initialized || !inlineVideo.offsetParent) return;
      initialized = true;

      if (startVideo?.getAttribute?.('data-src')) {
        startVideo.setAttribute('src', startVideo.getAttribute('data-src'));
      }

      if (loopVideo?.getAttribute?.('data-src')) {
        loopVideo.setAttribute('src', loopVideo.getAttribute('data-src'));
      }

      if (!startVideo) {
        loopVideo?.classList?.remove('hidden');
      }

      inlineVideo.addEventListener('sal:in', () => {
        if (startVideo) {
          if (loopVideo) {
            startVideo.addEventListener('ended', () => {
              loopVideo.play();
              startVideo.classList.add('hidden');
              loopVideo.classList.remove('hidden');
            }, false);
          }
          startVideo?.play();
        } else {
          loopVideo?.play();
        }
      });
    }

    window.addEventListener('widthResize', initialize);

    initialize();
  });
};
